export default __webpack_public_path__ + "static/media/auto_loans.c4ac5b66.jpg";